import { render, staticRenderFns } from "./CompraVentaDivisas.vue?vue&type=template&id=4347a552&"
import script from "./CompraVentaDivisas.vue?vue&type=script&lang=js&"
export * from "./CompraVentaDivisas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports